import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Toast } from 'react-weui';
import { formatNumber, formatDate } from 'lib/formatter.ts';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import * as MobileActions from 'actions/index.ts';
import Http from 'services/http2';
import CompanyService from 'services/company2';
import Util from 'lib/util.js';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import CustFieldService from 'services/custField';
import BodyCustField from 'components/bodyCustField';
import Big from 'big.js';
const isBig = Util.isBig;

// 送货单-送货数量修改

const Config = {
  deliveryNotice: {
    title: '送货单',
    apiPath: '/deliveryNotice/singleUpdate',
  },
};

const styles = theme => ({
  paper: {
    margin: '10px',
    width: '90vw',
  },
});

class DeliveryItemsUpdate extends Component {
  static propTypes = {
    currItem: PropTypes.object,
    unitNum: PropTypes.object,
    type: PropTypes.string,
    operateType: PropTypes.number,
    detail: PropTypes.detail,
  };

  static defaultProps = {
    currItem: {},
    unitNum: {},
    type: 'deliveryNotice',
    operateType: 1, //1修改；2删除
    detail: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      errorMsg: '',
      inviteCode: '',
      inviteCompanyCode: '',
      showLoading: false,
      storageQty: '',
      receiveQty: '',
      returnQty: '',
      remark: '',
      unitWeightList: [],
      countryList: [],
    };
    this.config = Config[this.props.type];
  }

  init() {
    const { isPurchase, detail } = this.props;
    if (!isPurchase) {
      CompanyService.getCompEnumList(
        detail.customerCode,
        'B2b_Unit_Weight_Code'
      ).then(res => {
        let arr = res.map(item => {
          return { id: item.subKey, text: item.subValue };
        });
        this.setState({ unitWeightList: arr });
      });

      CompanyService.getCompEnumList(
        detail.customerCode,
        'B2b_Erp_Country'
      ).then(res => {
        let arr = res.map(item => {
          return { id: item.subKey, text: item.subValue };
        });
        this.setState({ countryList: arr });
      });
    }
  }

  componentDidMount() {
    this.init();
  }

  componentWillUnmount() {}

  handleClose = () => {
    const { actions } = this.props;
    actions.closeQtyReviseModal();
  };

  setBodyCustData = data => {
    const { currItem } = this.props;
    currItem.dnLineExtend = data;
    this.setState({ ['dnLineExtend']: data });
  };

  handleChange = (event, key) => {
    const { currItem } = this.props;
    let val = event.target.value;
    currItem[key] = val;
    if (key === 'deliveryQty') {
      if (
        !currItem.isEditDeliveryValuationQty &&
        isBig(currItem.deliveryQty, currItem.slewRate)
      ) {
        //如果未开启计价数量可维护，自动根据slewRate计算计价数量
        currItem.deliveryValuationQty = Big(currItem.deliveryQty)
          .times(currItem.slewRate)
          .valueOf();
      }
    }
    if (key === 'applyDeliveryQty') {
      currItem.deliveryQty = currItem.applyDeliveryQty;
      if (
        !currItem.isEditDeliveryValuationQty &&
        isBig(currItem.deliveryQty, currItem.slewRate)
      ) {
        //如果未开启计价数量可维护，自动根据slewRate计算计价数量
        currItem.deliveryValuationQty = Big(currItem.deliveryQty)
          .times(currItem.slewRate)
          .valueOf();
      }
      if (
        !currItem.isEditDeliveryValuationQty &&
        isBig(currItem.applyDeliveryQty, currItem.slewRate)
      ) {
        //如果未开启计价数量可维护，自动根据slewRate计算计价数量
        currItem.applyDeliveryValuationQty = Big(currItem.applyDeliveryQty)
          .times(currItem.slewRate)
          .valueOf();
      }
    }
    this.setState({ [key]: val });
  };

  // 下拉改变
  handleSelectChange(event, name, arr) {
    const { currItem } = this.props;
    let value = event.target.value;
    let code = event.target.name;
    let text = arr.filter(item => item.id === value)[0].text;
    currItem[code] = value;
    currItem[name] = text;
    this.setState({ [code]: value });
    this.setState({ [name]: text });
  }

  // 日期改变
  handleDateChange(event, key) {
    const { currItem } = this.props;
    let ts = event.target.valueAsNumber;
    let value = formatDate(ts, 'YYYY-MM-DD');
    currItem[key] = value;
    this.setState({ [key]: value });
  }

  // 数量改变
  handleQtyChange(event, key) {
    const { currItem } = this.props;
    let value = event.target.value;
    if (/^\d*(\.\d*)?$/.test(value) === false || value === '.') {
      //允许 '', '5.' 以方便用户输入
      value = 0;
    }
    currItem[key] = value;
    this.setState({ [key]: value });
  }

  handleBlur = (event, key) => {
    const { currItem } = this.props;
    let val = event.target.value;
    if (val === '' || val.trim() === '') {
      currItem[key] = 0;
      this.setState({ [key]: 0 });
    }
  };

  handleFieldSelectChange(event, key) {
    const { currItem } = this.props;
    let val = event.target.value;
    currItem[key] = val;
    this.setState({ [key]: val });
  }

  handleFieldInputChange(event, key, type) {
    const { currItem } = this.props;
    let val = event.target.value;
    if (type === 0) {
      val = Util.qtyChange(event.target.value);
    }
    currItem[key] = val;
    this.setState({ [key]: val });
  }

  // 自定义时间变更
  handleFieldDateChange(event, key) {
    const { currItem } = this.props;
    if (event.target.value) {
      currItem[key] = event.target.valueAsNumber - 28800000;
      currItem[key] = formatDate(currItem[key], 'YYYY-MM-DD') || '';
      currItem[key + 'Date'] = currItem[key];
    }
    this.setState({ [key]: currItem[key] });
  }

  //保存
  handleOk = () => {
    const { currItem, operateType, detail, isPurchase, fieldSetting } =
      this.props;
    if (!this.check(currItem) && operateType === 1) {
      return;
    }
    let postbody = {};
    //单身自定义字段
    let bodyData = CustFieldService.getBodyData(
      fieldSetting,
      currItem.dnLineExtend,
      isPurchase
    );
    if (!isPurchase) {
      postbody = {
        companyCode: currItem.companyCode,
        lineNo: currItem.lineNo,
        dnXkNo: currItem.dnXkNo,
        remark: currItem.remark,
        grossWeight: currItem.grossWeight,
        netWeight: currItem.netWeight,
        unitWeightCode: currItem.unitWeightCode,
        unitWeightName: currItem.unitWeightName,
        batchNumber: currItem.batchNumber,
        productionDate: currItem.productionDate,
        sellByDate: currItem.sellByDate,
        packingQty: currItem.packingQty,
        brandName: currItem.brandName,
        originalCountryCode: currItem.originalCountryCode,
        originalCountryName: currItem.originalCountryName,
        prodLength: currItem.prodLength,
        prodWidth: currItem.prodWidth,
        prodHeight: currItem.prodHeight,
        deliveryQty: operateType === 1 ? currItem.deliveryQty : undefined,
        deliveryValuationQty:
          operateType === 1 && currItem.isEditDeliveryValuationQty
            ? currItem.deliveryValuationQty
            : undefined,
        applyDeliveryQty:
          operateType === 1 && detail.deliveryApplyFlag === 1
            ? currItem.applyDeliveryQty
            : undefined,
        applyDeliveryValuationQty:
          operateType === 1 && detail.deliveryApplyFlag === 1
            ? currItem.applyDeliveryValuationQty
            : undefined,
        operateType: operateType,
        dnLineExtend: bodyData,
        apiPath: this.config.apiPath,
      };
    } else {
      postbody = {
        companyCode: currItem.companyCode,
        dnXkNo: currItem.dnXkNo,
        lineList: [
          {
            deliveryQty: currItem.deliveryQty,
            deliveryValuationQty: currItem.deliveryValuationQty,
            lineNo: currItem.lineNo,
            poLineNo: currItem.poLineNo,
          },
        ],
        apiPath: '/vdeliveryNotice/updateCustomInfo',
      };

      if (detail.status === 1) {
        postbody = {
          companyCode: currItem.companyCode,
          dnXkNo: currItem.dnXkNo,
          lineList: [
            {
              // extendN01: currItem.extendN01,
              // extendN02: currItem.extendN02,
              // extendN03: currItem.extendN03,
              // extendN04: currItem.extendN04,
              ...bodyData,
              lineNo: currItem.lineNo,
              poLineNo: currItem.poLineNo,
            },
          ],

          apiPath: '/vdeliveryNotice/updateCustomInfo',
        };
      }
    }

    this.setState({ showLoading: true });
    Http.post('/api/cloudCenter?btnId=001', postbody).then(response => {
      this.setState({ showLoading: false });
      if (response.success) {
        this.setState({ errorMsg: '' });
        this.props.onChange('success');
        this.handleClose();
      } else {
        this.setState({ errorMsg: response.errorMsg });
      }
    });
  };

  check = currItem => {
    let result = true;
    //let deliveryQty = currItem.deliveryQty ? currItem.deliveryQty : 0;
    //deliveryQty = parseFloat(deliveryQty);

    if (currItem.deliveryQty === 0) {
      this.setState({ errorMsg: '送货数量不得为零' });
      return false;
    }
    return result;
  };

  render() {
    const {
      classes,
      data,
      currItem,
      unitNum,
      operateType,
      detail,
      fieldSetting,
      isPurchase,
    } = this.props;

    return (
      <div>
        <Dialog
          classes={{ paper: classes.paper }}
          open={data.showQtyRevise}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">
            {operateType === 1 ? '编辑产品明细' : '删除明细'}
          </DialogTitle>
          <DialogContent>
            <ul>
              <li className="dialog order-detail-item">
                <div className="line">
                  <span>项次：</span>
                  <div>{currItem.lineNo}</div>
                </div>
                <div className="line">
                  <span>物料编码：</span>
                  <div>{currItem.productCode}</div>
                </div>
                <div className="line">
                  <span>物料名称：</span>
                  <div>{currItem.productName}</div>
                </div>
                <div className="line">
                  <span>物料规格：</span>
                  <div>{currItem.productScale}</div>
                </div>
                <div className="line">
                  <span>客户单号：</span>
                  <div>
                    {currItem.poErpNo}({currItem.poLineNo})
                  </div>
                </div>
                {operateType === 1 && detail.deliveryApplyFlag === 1 && (
                  <div className="line">
                    <span>申请数量：</span>
                    <div>
                      {!isPurchase && (
                        <input
                          type="text"
                          value={currItem.applyDeliveryQty}
                          onChange={e =>
                            this.handleChange(e, 'applyDeliveryQty')
                          }
                          onBlur={e => this.handleBlur(e, 'applyDeliveryQty')}
                        />
                      )}
                      {isPurchase && <span>{currItem.applyDeliveryQty}</span>}
                    </div>
                  </div>
                )}
                {operateType === 1 && (
                  <div className="line">
                    <span>送货数量：</span>
                    <div>
                      {((!isPurchase && detail.deliveryApplyFlag !== 1) ||
                        (detail.deliveryApplyFlag === 1 &&
                          isPurchase &&
                          detail.status === 5)) && (
                        <input
                          type="text"
                          value={currItem.deliveryQty}
                          onChange={e => this.handleChange(e, 'deliveryQty')}
                          onBlur={e => this.handleBlur(e, 'deliveryQty')}
                        />
                      )}
                      {!(
                        (!isPurchase && detail.deliveryApplyFlag !== 1) ||
                        (detail.deliveryApplyFlag === 1 &&
                          isPurchase &&
                          detail.status === 5)
                      ) && <span>{currItem.deliveryQty}</span>}
                    </div>
                  </div>
                )}
                {operateType === 1 && detail.deliveryApplyFlag === 1 && (
                  <div className="line">
                    <span>申请计价数量：</span>
                    <div>
                      {(!currItem.isEditDeliveryValuationQty || isPurchase) && (
                        <div>
                          {formatNumber(
                            currItem.applyDeliveryValuationQty,
                            unitNum.Quantity_Decimal_Place
                          )}
                        </div>
                      )}
                      {currItem.isEditDeliveryValuationQty && !isPurchase && (
                        <div>
                          <input
                            type="text"
                            value={currItem.applyDeliveryValuationQty}
                            onChange={e =>
                              this.handleChange(e, 'applyDeliveryValuationQty')
                            }
                            onBlur={e =>
                              this.handleBlur(e, 'applyDeliveryValuationQty')
                            }
                          />
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {operateType === 1 && (
                  <div className="line">
                    <span>计价数量：</span>
                    {!(
                      (currItem.isEditDeliveryValuationQty &&
                        detail.deliveryApplyFlag !== 1 &&
                        !isPurchase) ||
                      (isPurchase &&
                        detail.deliveryApplyFlag === 1 &&
                        detail.status === 5)
                    ) && (
                      <div>
                        {formatNumber(
                          currItem.deliveryValuationQty,
                          unitNum.Quantity_Decimal_Place
                        )}
                      </div>
                    )}
                    {((currItem.isEditDeliveryValuationQty &&
                      detail.deliveryApplyFlag !== 1 &&
                      !isPurchase) ||
                      (isPurchase &&
                        detail.deliveryApplyFlag === 1 &&
                        detail.status === 5)) && (
                      <div>
                        <input
                          type="text"
                          value={currItem.deliveryValuationQty}
                          onChange={e =>
                            this.handleChange(e, 'deliveryValuationQty')
                          }
                          onBlur={e =>
                            this.handleBlur(e, 'deliveryValuationQty')
                          }
                        />
                      </div>
                    )}
                  </div>
                )}
                {operateType === 1 && (
                  <div className="line">
                    <span>备注：</span>
                    <div>
                      {!isPurchase && (
                        <input
                          type="text"
                          value={currItem.remark || ''}
                          onChange={e => this.handleChange(e, 'remark')}
                          onBlur={e => this.handleBlur(e, 'remark')}
                        />
                      )}
                      {isPurchase && <span>{currItem.remark}</span>}
                    </div>
                  </div>
                )}
                {/* 单身自定义字段 */}
                {operateType === 1 && (
                  <BodyCustField
                    fieldSetting={fieldSetting}
                    line={currItem.dnLineExtend}
                    bodyCustData={currItem.dnLineExtend}
                    setBodyCustData={this.setBodyCustData}
                    isEdit={true}
                  ></BodyCustField>
                )}

                {/* 单身显示字段 */}
                {operateType === 1 && fieldSetting.bodyShow?.grossWeight && (
                  <div className="line">
                    <span>毛重：</span>
                    <div>
                      <input
                        type="text"
                        value={currItem.grossWeight || ''}
                        onChange={e => this.handleQtyChange(e, 'grossWeight')}
                      />
                    </div>
                  </div>
                )}
                {operateType === 1 && fieldSetting.bodyShow?.netWeight && (
                  <div className="line">
                    <span>净重：</span>
                    <div>
                      <input
                        type="text"
                        value={currItem.netWeight || ''}
                        onChange={e => this.handleQtyChange(e, 'netWeight')}
                      />
                    </div>
                  </div>
                )}
                {operateType === 1 && fieldSetting.bodyShow?.unitWeightName && (
                  <div className="line">
                    <span>净重单位：</span>
                    <div>
                      {this.state.unitWeightList && (
                        <FormControl
                          variant="outlined"
                          margin="normal"
                          fullWidth
                        >
                          <Select
                            value={currItem.unitWeightCode || ''}
                            onChange={e =>
                              this.handleSelectChange(
                                e,
                                'unitWeightName',
                                this.state.unitWeightList
                              )
                            }
                            input={
                              <OutlinedInput
                                labelWidth={0}
                                name="unitWeightCode"
                                id="outlined-formTypeCode-simple"
                              />
                            }
                          >
                            {this.state.unitWeightList.map((item, index) => (
                              <MenuItem key={index} value={item.id}>
                                {item.text}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      )}
                    </div>
                  </div>
                )}
                {operateType === 1 && fieldSetting.bodyShow?.batchNumber && (
                  <div className="line">
                    <span>批号：</span>
                    <div>
                      <input
                        type="text"
                        value={currItem.batchNumber || ''}
                        onChange={e => this.handleChange(e, 'batchNumber')}
                      />
                    </div>
                  </div>
                )}
                {operateType === 1 && fieldSetting.bodyShow?.productionDate && (
                  <div className="line">
                    <span>生产日期：</span>
                    <div className="field-value">
                      <React.Fragment>
                        <form noValidate>
                          <TextField
                            value={currItem.productionDate || ''}
                            onChange={e =>
                              this.handleDateChange(e, 'productionDate')
                            }
                            id="productionDate"
                            type="date"
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </form>
                      </React.Fragment>
                    </div>
                  </div>
                )}
                {operateType === 1 && fieldSetting.bodyShow?.sellByDate && (
                  <div className="line">
                    <span>保质期：</span>
                    <div>
                      <input
                        type="text"
                        value={currItem.sellByDate || ''}
                        onChange={e => this.handleQtyChange(e, 'sellByDate')}
                      />
                    </div>
                  </div>
                )}
                {operateType === 1 && fieldSetting.bodyShow?.packingQty && (
                  <div className="line">
                    <span>包装数量：</span>
                    <div>
                      <input
                        type="text"
                        value={currItem.packingQty || ''}
                        onChange={e => this.handleQtyChange(e, 'packingQty')}
                      />
                    </div>
                  </div>
                )}
                {operateType === 1 && fieldSetting.bodyShow?.brandName && (
                  <div className="line">
                    <span>品牌：</span>
                    <div>
                      <input
                        type="text"
                        value={currItem.brandName || ''}
                        onChange={e => this.handleChange(e, 'brandName')}
                      />
                    </div>
                  </div>
                )}
                {operateType === 1 &&
                  fieldSetting.bodyShow?.originalCountryName && (
                    <div className="line">
                      <span>原产国：</span>
                      <div>
                        {this.state.countryList && (
                          <FormControl
                            variant="outlined"
                            margin="normal"
                            fullWidth
                          >
                            <Select
                              value={currItem.originalCountryCode || ''}
                              onChange={e =>
                                this.handleSelectChange(
                                  e,
                                  'originalCountryName',
                                  this.state.countryList
                                )
                              }
                              input={
                                <OutlinedInput
                                  labelWidth={0}
                                  name="originalCountryCode"
                                  id="outlined-formTypeCode-simple"
                                />
                              }
                            >
                              {this.state.countryList.map((item, index) => (
                                <MenuItem key={index} value={item.id}>
                                  {item.text}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        )}
                      </div>
                    </div>
                  )}
                {operateType === 1 && fieldSetting.bodyShow?.prodLength && (
                  <div className="line">
                    <span>长(cm)：</span>
                    <div>
                      <input
                        type="text"
                        value={currItem.prodLength || ''}
                        onChange={e => this.handleQtyChange(e, 'prodLength')}
                      />
                    </div>
                  </div>
                )}
                {operateType === 1 && fieldSetting.bodyShow?.prodWidth && (
                  <div className="line">
                    <span>宽(cm)：</span>
                    <div>
                      <input
                        type="text"
                        value={currItem.prodWidth || ''}
                        onChange={e => this.handleQtyChange(e, 'prodWidth')}
                      />
                    </div>
                  </div>
                )}
                {operateType === 1 && fieldSetting.bodyShow?.prodHeight && (
                  <div className="line">
                    <span>高(cm)：</span>
                    <div>
                      <input
                        type="text"
                        value={currItem.prodHeight || ''}
                        onChange={e => this.handleQtyChange(e, 'prodHeight')}
                      />
                    </div>
                  </div>
                )}
                {this.state.errorMsg && (
                  <p className="error-tip">{this.state.errorMsg}</p>
                )}
              </li>
            </ul>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              取消
            </Button>
            {operateType === 1 && (
              <Button onClick={this.handleOk} color="primary">
                确定
              </Button>
            )}
            {operateType === 2 && (
              <Button onClick={this.handleOk} color="secondary">
                确认删除
              </Button>
            )}
          </DialogActions>
        </Dialog>
        <Toast icon="loading" show={this.state.showLoading}>
          Loading...
        </Toast>
      </div>
    );
  }
}

DeliveryItemsUpdate.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
  return {
    data: state.modal,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(DeliveryItemsUpdate));
